import {
  Typography,
  Stack,
  Card,
  CardContent,
  CardActions,
  Button,
} from '@mui/material'
import { ArrowForwardIos } from '@mui/icons-material'
import CircularProgress from '@mui/material/CircularProgress'
import currencyFormatter from 'helpers/formats/currency'
import redirect from 'helpers/redirect'
import { PATH_DASHBOARD } from 'src/routes/paths'
import trackEvent from 'src/trackers'
import { useRouter } from 'next/router'
import useAuth from 'hooks/useAuth'
import useLocales from 'hooks/useLocales'

interface IIncomeOverviewProps {
  isLoading: boolean
  totalIncome: number
  totalTransaction: number
  month: string
  year: number
}

export default function IncomeOverview({
  isLoading,
  totalIncome,
  totalTransaction,
  month,
  year,
}: IIncomeOverviewProps) {
  const { t } = useLocales()
  const { user } = useAuth()
  const { pathname, query } = useRouter()
  const trackerData = { pathname, query, user }

  return (
    <Card
      sx={{
        padding: {
          lg: '24px 0px',
          xl: '14px',
        },
      }}
    >
      <CardContent>
        <Stack
          direction={'row'}
          sx={{ justifyContent: 'space-between' }}
        >
          <Stack>
            <Typography variant="h6">
              {t('key_total_sales')}
            </Typography>
            <Typography color={'#6B6879'}>
              {month + ' ' + year}
            </Typography>
            <Typography variant="h3">
              {isLoading ? (
                <CircularProgress size={20} />
              ) : (
                currencyFormatter(totalIncome)
              )}
            </Typography>
          </Stack>
          <Stack>
            <Typography variant="h6">
              {t('key_total_transaction')}
            </Typography>
            <Typography color={'#6B6879'}>
              {month + ' ' + year}
            </Typography>
            <Typography variant="h3">{totalTransaction}</Typography>
          </Stack>
        </Stack>
      </CardContent>
      <CardActions>
        <Button
          variant="text"
          color="secondary"
          endIcon={<ArrowForwardIos />}
          onClick={() => {
            trackEvent.revenue(
              'click_view_revenue_history',
              trackerData,
            )
            redirect(`${PATH_DASHBOARD.creator_center.revenue}`)
          }}
        >
          {t('key_view_sales')}
        </Button>
      </CardActions>
    </Card>
  )
}
